module.exports = __webpack_public_path__ + "static/media/ai-approval.318b5ef3d3a4ebaedede5900f7a457cf.svg";